// ============================================================
//  src/security.js — Helpers de seguridad para URLs dinámicas
// ============================================================

/**
 * Devuelve una URL segura para usar en href o src.
 * Solo permite http: y https:
 * Bloquea javascript:, data:, file:, vbscript:, etc.
 *
 * @param {string} url
 * @returns {string}
 */
export function safeUrl(url) {
    const valor = String(url || '').trim();

    if (!valor) return '';

    try {
        const parsed = new URL(valor);
        const protocolo = parsed.protocol.toLowerCase();

        if (protocolo === 'http:' || protocolo === 'https:') {
            return parsed.toString();
        }

        return '';
    } catch {
        return '';
    }
}